/* eslint-disable  */
/* eslint-disable import/no-unresolved */
import { useFormik } from "formik";
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import CustomLabel from "src/shared/CustomLabel";
// import CustomRadioButton from "src/shared/CustomRadioButton";
import CustomReviewField from "src/shared/CustomReviewField";
import CustomizedSwitches from "src/shared/CustomToggleButton";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

function CovidAndNriReview() {
  const covidAndNriDetails = useAppSelector((state: any) => state.covidAndNriDetails);
  const generalDetails = useAppSelector((state) => state.proposerDetails.general);
  // console.log("covidAndNriDetails", covidAndNriDetails);
  const {
    // isValid,
    // setFieldTouched,
    setFieldValue
  } = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {
      covidQuarantine: "",
      covidComplication: "",
      dateOfFirstDose: "",
      dateofSecondDose: "",
      dateOfBoosterDose: "",
      currentCountry: "New",
      cityOfResidence: "",
      lastDateOfEntryToIn: "",
      exitDateFromIndia: "",
      durationOfStayAbroad: "",
      purposeOfStayAbroad: "",
      insurancePurpose: ""
    },
    // validationSchema: validationSchema(),
    onSubmit: (fieldValues) => {}
  });

  return (
    <div>
      {/* Commented out the COVID section as it's no longer needed but can be reused if required. */}
      {/* <div className="flex mt-7 text-sm justify-between">
        <p className=" w-10/12">
          Have you ever tested positive for the novel coronavirus (SARS-CoV-2/COVID-19)? If yes,
          provide the date of positive diagnosis. And details of subsequent tests
        </p>
        <CustomizedSwitches
          isEnabled={false}
          toggleState={covidAndNriDetails.covidTest.covidPositive}
          setFieldValue={setFieldValue}
          fieldObj="covidTest"
          fieldName="covidPositive"
        />
      </div>
      {covidAndNriDetails.covidTest.covidPositive && (
        <>
          <div className="mt-7 text-sm">
            <p>
              a. Whether you were hospitalized, or Asymptomatic home quarantined Hospitalized Home
              quarantine
            </p>
            <CustomRadioButton
              name="covidQuarantine"
              disabled
              label="Covid"
              options={["Hospitalized", "Home Quarantined"]}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              defaultValue={covidAndNriDetails.covidTest.covidQuarantine}
            />
          </div>
          <div className="mt-7 text-sm">
            <p>b. Whether you suffered Covid-19 related Complications?</p>
            <CustomRadioButton
              //   className={`${values.title === "Others" ? "col-span-2" : "col-span-3 "}`}
              disabled
              name="covidComplication"
              label="Covid"
              options={["Hospitalized", "Home Quarantined"]}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              //   error={getIn(errors, "gender")}
              //   touched={getIn(touched, "gender")}
              defaultValue={covidAndNriDetails.covidTest.covidComplication}
            />
          </div>
        </>
      )}
      <hr className="border-dashed border-t-2 mt-7 mb-6.5 border-daintree  opacity-10" />
      <div>
        <div className="flex mt-7 text-sm justify-between">
          <p>Have you been vaccinated for COVID19?</p>
          <CustomizedSwitches
            isEnabled={false}
            toggleState={covidAndNriDetails.covidVaccineDates.covidVaccinated}
            fieldObj="covidVaccineDates"
            fieldName="covidVaccinated"
            setFieldValue={setFieldValue}
          />
        </div>

        {covidAndNriDetails.covidVaccineDates.covidVaccinated && (
          <div className="grid grid-flow-row-dense md:grid-cols-4 sm:grid-cols-3 max-sm:grid-cols-2 gap-x-3  mt-4 gap-y-4 ">
            <div className="col-span-1">
              <CustomLabel>Date of First Dose</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.covidVaccineDates?.dateOfFirstDose || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>Date of Second Dose</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.covidVaccineDates?.dateOfSecondDose || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>Date of Booster Dose</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.covidVaccineDates?.dateOfBoosterDose || "-"}
              </CustomReviewField>
            </div>
          </div>
        )}
      </div> */}
      {generalDetails?.nationalityCode !== "RES" && (
        <div>
          {/* <div className="mt-7 mb-7">
            <div className="text-base font-bold">NRI Details</div>
          </div>
          <hr /> */}
          <div className="grid grid-flow-row-dense lg:grid-cols-4 grid-cols-2 gap-x-2 mt-4 gap-y-4 ">
            <div className="col-span-1">
              <CustomLabel>Current Country</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.nriDetails?.currentCountry || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>City Of Residence</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.nriDetails?.cityOfResidence || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>Last Date Of Entry to India</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.nriDetails?.lastDateOfEntryToIn || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>Exit Date From India</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.nriDetails?.exitDateFromIndia || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>How long have you been staying abroad (Months)?</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.nriDetails?.durationOfStayAbroad || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1 pr-1">
              <CustomLabel>What is purpose of your stay abroad?</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.nriDetails?.purposeOfStayAbroad || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>What is purpose of taking insurance from India?</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.nriDetails?.insurancePurpose || "-"}
              </CustomReviewField>
            </div>
          </div>
          <div className="flex mt-7 text-sm justify-between">
            <p>
              Do you travel to any other country? If yes, then please specify the country(ies)
              names, purpose and duration of stay in these countries.*
            </p>

            <CustomizedSwitches
              isEnabled={false}
              toggleState={covidAndNriDetails.otherCountryTravel.isOtherCountryTravel}
              fieldObj="otherCountryTravel"
              fieldName="isOtherCountryTravel"
              setFieldValue={setFieldValue}
            />
          </div>
          {covidAndNriDetails.otherCountryTravel.isOtherCountryTravel && (
            <div className="grid grid-flow-row-dense lg:grid-cols-4 md:grid-cols-3 max-sm:grid-cols-2 gap-x-3  mt-4 gap-y-4 ">
              <div className="col-span-1">
                <CustomLabel>Country Name</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.otherCountryTravel?.countryName || "-"}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Duration(Months)</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.otherCountryTravel?.duration || "-"}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Purpose</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.otherCountryTravel?.purpose || "-"}
                </CustomReviewField>
              </div>
            </div>
          )}
          <hr className="border-dashed border-t-2 mt-7 mb-6.5 border-daintree  opacity-10" />
          <div>
            <div className="mt-7 text-sm">
              What is your occupation & also mention your occupational duties and responsibilities?
            </div>
            <CustomReviewField>
              {covidAndNriDetails?.occupationDetails?.occupationNameAndRole || "-"}
            </CustomReviewField>
          </div>
          <hr className="border-dashed border-t-2 mt-7 mb-6.5 border-daintree  opacity-10" />
          <div className="flex mt-7 text-sm justify-between">
            <p>
              If you are salaried then, please give the details of company, Designation & monthly
              income from employment abroad? (Also mentioned details of currency)*
            </p>
            <CustomizedSwitches
              isEnabled={false}
              toggleState={covidAndNriDetails.salaried.isSalaried}
              fieldObj="salaried"
              fieldName="isSalaried"
              setFieldValue={setFieldValue}
            />
          </div>
          {covidAndNriDetails.salaried.isSalaried && (
            <div className="grid grid-flow-row-dense lg:grid-cols-4 md:grid-cols-3 max-sm:grid-cols-2 gap-x-3  mt-4 gap-y-4 ">
              <div className="col-span-1">
                <CustomLabel>Country Name</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.salaried?.companyName || "-"}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Designation</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.salaried?.designation || "-"}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Currency</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.salaried?.currency || "-"}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Monthly Income</CustomLabel>
                <CustomReviewField>
                  {onChangeIndianCurrency(covidAndNriDetails?.salaried?.monthlyIncome || "-")}
                </CustomReviewField>
              </div>
            </div>
          )}
          <hr className="border-dashed border-t-2 mt-7 mb-6.5 border-daintree  opacity-10" />
          <div className=" flex mt-7 text-sm justify-between">
            <p>
              If you are self-employed then,what is your Gross Turnover and annual income (Net
              Profit) from business abroad
            </p>
            <CustomizedSwitches
              isEnabled={false}
              toggleState={covidAndNriDetails.selfEmployed.isSelfEmployed}
              fieldObj="salaried"
              fieldName="isSalaried"
              setFieldValue={setFieldValue}
            />
          </div>

          {covidAndNriDetails.selfEmployed.isSelfEmployed && (
            <div className="grid grid-flow-row-dense lg:grid-cols-4 md:grid-cols-3 max-sm:grid-cols-2 gap-x-3  mt-4 gap-y-4 ">
              <div className="col-span-1">
                <CustomLabel>Gross Turnover</CustomLabel>
                <CustomReviewField>
                  {onChangeIndianCurrency(covidAndNriDetails?.selfEmployed?.grossTurnover || "-")}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Annual Income</CustomLabel>
                <CustomReviewField>
                  {onChangeIndianCurrency(covidAndNriDetails?.selfEmployed?.annualIncome || "-")}
                </CustomReviewField>
              </div>
            </div>
          )}
          <hr className="border-dashed border-t-2 mt-7 mb-6.5 border-daintree  opacity-10" />
          <div className="mt-7 text-sm">
            <p>
              Kindly provide the name of the Bank, Branch and the account number through which you
              will be paying the premium
            </p>
          </div>
          <div className="grid grid-flow-row-dense lg:grid-cols-4 md:grid-cols-3 max-sm:grid-cols-2 gap-x-3  mt-4 gap-y-4 ">
            <div className="col-span-1">
              <CustomLabel>Name Of The Bank</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.bankDetails?.nameOfTheBank || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>Branch</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.bankDetails?.branch || "-"}
              </CustomReviewField>
            </div>
            <div className="col-span-1">
              <CustomLabel>Account Number</CustomLabel>
              <CustomReviewField>
                {covidAndNriDetails?.bankDetails?.accountNumber || "-"}
              </CustomReviewField>
            </div>
          </div>
          <hr className="border-dashed border-t-2 mt-7 mb-6.5 border-daintree  opacity-10" />
          <div className="mt-7 text-sm">
            <p>Your full address in the country of your residence</p>
            <CustomReviewField>
              {covidAndNriDetails?.residence?.nameOfTheBankResidence || "-"}
            </CustomReviewField>
          </div>
          <hr className="border-dashed border-t-2 mt-7 mb-6.5 border-daintree  opacity-10" />
          <div className="flex mt-7 text-sm justify-between">
            <p>
              Do you have any other insurance policy outside India? If Yes please provide detail.
            </p>
            <CustomizedSwitches
              isEnabled={false}
              toggleState={covidAndNriDetails.policyDetails.isOtherPolicyOutsideIndia}
              fieldObj="salaried"
              fieldName="isSalaried"
              setFieldValue={setFieldValue}
            />
          </div>
          {covidAndNriDetails.policyDetails.isOtherPolicyOutsideIndia && (
            <div className="grid grid-flow-row-dense lg:grid-cols-4 md:grid-cols-3 max-sm:grid-cols-2 gap-x-3  mt-4 gap-y-4 ">
              <div className="col-span-1">
                <CustomLabel>Insurer Name</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.policyDetails?.insurerName || "-"}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Sum Assured</CustomLabel>
                <CustomReviewField>
                  {onChangeIndianCurrency(covidAndNriDetails?.policyDetails?.sumAssured || "-")}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Premium Amount</CustomLabel>
                <CustomReviewField>
                  {onChangeIndianCurrency(covidAndNriDetails?.policyDetails?.premiumAccount || "-")}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Policy Status</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.policyDetails?.policyStatus || "-"}
                </CustomReviewField>
              </div>
              <div className="col-span-1">
                <CustomLabel>Date Of Insurance</CustomLabel>
                <CustomReviewField>
                  {covidAndNriDetails?.policyDetails?.dateOfInsurance || "-"}
                </CustomReviewField>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CovidAndNriReview;
